// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi_map.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/poi_map.proto.
 */
export const file_travplaces_v1_poi_map: GenFile = /*@__PURE__*/
  fileDesc("Cht0cmF2cGxhY2VzL3YxL3BvaV9tYXAucHJvdG8SDXRyYXZwbGFjZXMudjEiWwoUR2V0UG9pR2VvanNvblJlcXVlc3QSDwoHY2l0eV9pZBgBIAEoCRIVCg1jYXRlZ29yeV9rZXlzGAIgAygJEg0KBWxpbWl0GAMgASgFEgwKBGJib3gYBCADKAEiKAoVR2V0UG9pR2VvanNvblJlc3BvbnNlEg8KB2dlb2pzb24YASABKAkyeAoNUG9pTWFwU2VydmljZRJnCg1HZXRQb2lHZW9qc29uEiMudHJhdnBsYWNlcy52MS5HZXRQb2lHZW9qc29uUmVxdWVzdBokLnRyYXZwbGFjZXMudjEuR2V0UG9pR2VvanNvblJlc3BvbnNlIguK6jADCgEKkOowAUKmAQoRY29tLnRyYXZwbGFjZXMudjFCC1BvaU1hcFByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * @generated from message travplaces.v1.GetPoiGeojsonRequest
 */
export type GetPoiGeojsonRequest = Message<"travplaces.v1.GetPoiGeojsonRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: repeated string category_keys = 2;
   */
  categoryKeys: string[];

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * The ground to fetch, as [min_lng, min_lat, max_lng, max_lat].
   *
   * Empty means the whole city. The browsing layer sends what the map is
   * looking at and asks again when it moves somewhere it has not read: a
   * city of eleven thousand places is nearly two megabytes of GeoJSON, and
   * the limit that keeps that in check cuts the list alphabetically — so
   * ticking every kind drew the first four thousand by name and nothing
   * after, which is not a map of anything.
   *
   * The avoidance preview sends nothing, deliberately: that layer is a
   * claim about what the route will keep clear of, and narrowing it to
   * what happens to be on screen would promise less than the plan
   * delivers.
   *
   * @generated from field: repeated double bbox = 4;
   */
  bbox: number[];
};

/**
 * Describes the message travplaces.v1.GetPoiGeojsonRequest.
 * Use `create(GetPoiGeojsonRequestSchema)` to create a new message.
 */
export const GetPoiGeojsonRequestSchema: GenMessage<GetPoiGeojsonRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_map, 0);

/**
 * @generated from message travplaces.v1.GetPoiGeojsonResponse
 */
export type GetPoiGeojsonResponse = Message<"travplaces.v1.GetPoiGeojsonResponse"> & {
  /**
   * A GeoJSON FeatureCollection, serialised as JSON, ready for MapLibre.
   *
   * @generated from field: string geojson = 1;
   */
  geojson: string;
};

/**
 * Describes the message travplaces.v1.GetPoiGeojsonResponse.
 * Use `create(GetPoiGeojsonResponseSchema)` to create a new message.
 */
export const GetPoiGeojsonResponseSchema: GenMessage<GetPoiGeojsonResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_map, 1);

/**
 * PoiMapService serves POIs as GeoJSON for the map's category browser.
 *
 * @generated from service travplaces.v1.PoiMapService
 */
export const PoiMapService: GenService<{
  /**
   * GetPoiGeojson returns a GeoJSON FeatureCollection of a city's active POIs,
   * optionally narrowed to a set of category keys, as a JSON string.
   *
   * @generated from rpc travplaces.v1.PoiMapService.GetPoiGeojson
   */
  getPoiGeojson: {
    methodKind: "unary";
    input: typeof GetPoiGeojsonRequestSchema;
    output: typeof GetPoiGeojsonResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_poi_map, 0);

